import Axios from "axios";

export const UPDATE_BASKET_ITEM_TOTAL = "UPDATE_BASKET_ITEM_TOTAL";
export const UPDATE_SETUPDATE = "UPDATE_SETUPDATE";
export const UPDATE_BASKET = "UPDATE_BASKET";
export const UPDATE_BASKET_QUANITIES = "UPDATE_BASKET_QUANITIES";
export const TOGGLE_BASKET_SUCCUESS = "TOGGLE_BASKET_SUCCUESS";
export const TOGGLE_BOTTOMBUTTONS_OPACITY = "TOGGLE_BOTTOMBUTTONS_OPACITY";
export const CLEAR_BASKET_INTERFACE = "CLEAR_BASKET_INTERFACE";
export const CHECKOUT_DATA_UPDATE = "CHECKOUT_DATA_UPDATE";
export const UPDATE_POSTAGE_OPTIONS = "UPDATE_POSTAGE_OPTIONS";
export const UPDATE_SELECTED_POSTAGE = "UPDATE_SELECTED_POSTAGE";
export const UPDATE_TOTALS_AFTER_COUPON = "UPDATE_TOTALS_AFTER_COUPON";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_BOTTOM_FOOTER_DATA = "UPDATE_BOTTOM_FOOTER_DATA";

let ITEMS = [];
let DEALS = [];

export const FetchBasketDeatils = () => {
    return (dispatch, getState) => {
        const data = { userID: getState().user.id };
        Axios.post("/pods/3dPrintingShop/frontEnd/getBasketItems", data)
            .then((res) => {
                const data = res.data;
                console.log("BASKET DATA: ", data);
                if (data.error == "null") {
                    const quantities = {};
                    const deals = [];
                    let basketTotal = 0;
                    let basketTotalWithoutDisounts = 0;
                    let partlyPaidItems = false;

                    ITEMS = data.items;

                    for (const item of ITEMS) {
                        quantities[item.uuid] = item.quantity;
                        let itemTotal = 0;

                        if (item.productDetails.deal != "") {
                            const deal = data.deals.find((de) => de.uuid == item.productDetails.deal);
                            const dealValid = WorkDeal(deal);
                            // if (dealValid) {
                            //     item.dealActive = true;
                            //     const testDeal = deals.find((de) => de.uuid == deal.uuid);
                            //     if (testDeal == null) {
                            //         if (deal.typeOff == "money") {
                            //             itemTotal = item.productDetails.price * item.quantity - parseInt(deal.typeValueOff);
                            //         }
                            //         deal.id = deals.length + 1;
                            //         deals.push(deal);
                            //         item.dealID = deal.id;
                            //     } else {
                            //         item.dealID = deal.id;
                            //         itemTotal = item.productDetails.price * item.quantity;
                            //     }
                            // } else {
                            item.dealActive = false;
                            // }
                        } else {
                            itemTotal = item.productDetails.price * item.quantity;
                        }
                        basketTotal = basketTotal + itemTotal;

                        console.log(basketTotal);

                        if (item.priceStatus == "dp") {
                            partlyPaidItems = true;
                            const fullTotal = parseInt(item.productDetails.fullPrice) * parseInt(item.quantity);
                            basketTotalWithoutDisounts = basketTotalWithoutDisounts + fullTotal;
                        } else {
                            basketTotalWithoutDisounts = basketTotalWithoutDisounts + itemTotal;
                        }
                    }

                    dispatch({
                        type: UPDATE_BASKET,
                        items: ITEMS,
                        serverQuanities: quantities,
                        basketQuantities: quantities,
                        basketTotal: basketTotal,
                        basketTotalWithoutDisounts: basketTotalWithoutDisounts,
                        partlyPaidItems: partlyPaidItems,
                        itemTotal: data.itemTotal,
                        deals: DEALS
                    });
                }
            })
            .catch((err) => console.log(err));
    };
};

export const ToggleBasketSuccess = (val) => {
    return {
        type: TOGGLE_BASKET_SUCCUESS,
        value: val
    };
};

export const ToggleBottomButtonsOpactiy = (val) => {
    return {
        type: TOGGLE_BOTTOMBUTTONS_OPACITY,
        value: val
    };
};

export const UpdateBasketItemTotal = () => {
    return (dispatch, getState) => {
        const data = { userID: getState().user.id };
        Axios.post("/pods/3dPrintingShop/frontEnd/getBasketTotal", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    dispatch({
                        type: UPDATE_BASKET_ITEM_TOTAL,
                        value: data.total
                    });
                }
            })
            .catch((err) => console.log(err));
    };
};

export const IncraseBasketItemQuantity = (itemUUID) => {
    return (dispatch, getState) => {
        const quantities = { ...getState().printingShop.basketQuantities };

        quantities[itemUUID] = quantities[itemUUID] + 1;

        dispatch(runCheckQuantities(quantities));

        dispatch({
            type: UPDATE_BASKET_QUANITIES,
            value: quantities
        });
    };
};

export const DecraseBasketItemQuantity = (itemUUID) => {
    return (dispatch, getState) => {
        if (getState().printingShop.basketQuantities[itemUUID] > 1) {
            const quantities = { ...getState().printingShop.basketQuantities };

            quantities[itemUUID] = quantities[itemUUID] - 1;

            dispatch(runCheckQuantities(quantities));

            dispatch({
                type: UPDATE_BASKET_QUANITIES,
                value: quantities
            });
        }
    };
};

const runCheckQuantities = (basketQ) => {
    return (dispatch, getState) => {
        let setUpdate = false;

        for (const [key, value] of Object.entries(getState().printingShop.serverQuanities)) {
            if (basketQ[key] !== value) {
                setUpdate = true;
            }
        }

        dispatch({
            type: UPDATE_SETUPDATE,
            value: setUpdate
        });
    };
};

export const UpdateBasketOnServer = () => {
    return (dispatch, getState) => {
        const data = { basketQuantities: getState().printingShop.basketQuantities };
        Axios.post("/pods/3dPrintingShop/frontEnd/updateBasket", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    dispatch(FetchBasketDeatils());

                    dispatch({
                        type: UPDATE_SETUPDATE,
                        value: false
                    });
                }
            })
            .catch((err) => console.log(err));
    };
};

export const RemoveItemFromBasket = (itemUUID) => {
    return (dispatch, getState) => {
        const data = { userID: getState().user.id, itemUUID };
        Axios.post("/pods/3dPrintingShop/frontEnd/removeItemFromBasket", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    dispatch(FetchBasketDeatils());
                }
            })
            .catch((err) => console.log(err));
    };
};

export const UpdateCheckoutFormData = (newData) => {
    return {
        type: CHECKOUT_DATA_UPDATE,
        value: newData
    };
};

export const LoadPostageOptionsAndTotals = (postageOptions, selectedPostage, postageActive, checkoutSubTotal, checkoutTotal) => {
    return {
        type: UPDATE_POSTAGE_OPTIONS,
        postageOptions: postageOptions,
        selectedPostage: selectedPostage,
        active: postageActive,
        checkoutSubTotal: checkoutSubTotal,
        checkoutTotal: checkoutTotal
    };
};

export const UpdatePostageSelectedAndTotals = (uuid, checkoutTotal) => {
    return {
        type: UPDATE_SELECTED_POSTAGE,
        value: uuid,
        checkoutTotal: checkoutTotal
    };
};

export const UpdateTotalsFromCoupon = (subTotalAfterCoupon, checkoutTotal, couponUUID) => {
    return {
        type: UPDATE_TOTALS_AFTER_COUPON,
        checkoutSubTotal: subTotalAfterCoupon,
        checkoutTotal: checkoutTotal,
        couponUUID: couponUUID
    };
};

export const UpdateSettings = (val) => {
    return {
        type: UPDATE_SETTINGS,
        value: val
    };
};

export const UpdateBottomFooterData = (val) => {
    return {
        type: UPDATE_BOTTOM_FOOTER_DATA,
        value: val
    };
};

function WorkDeal(deal) {
    let itemsToChange = [];
    if (deal.numberToInclude == "all") {
        for (const productCode of deal.productsIncluded) {
            for (const item of ITEMS) {
                if (item.productCode == productCode.productCode && !item.includedInDeal) {
                    if (!itemsToChange.includes(item.uuid)) {
                        itemsToChange.push(item.uuid);
                    }
                    break;
                }
            }
        }
        if (itemsToChange.length == deal.productsIncluded.length) {
            deal.id = DEALS.length + 1;
            DEALS.push(deal);
            for (const item of itemsToChange) {
                ITEMS.find((i) => i.uuid == item).includedInDeal = true;
                ITEMS.find((i) => i.uuid == item).dealID = deal.id;
            }
        } else {
            itemsToChange = [];
        }
    }

    console.log("IoC:", itemsToChange);
}
